export const GET_CATALOG_ITEMS = "GET_CATALOG_ITEMS"
export const GET_CATALOG_ITEMS_SUCCESS = "GET_CATALOG_ITEMS_SUCCESS"
export const GET_CATALOG_ITEMS_FAIL = "GET_CATALOG_ITEMS_FAIL"

export const ADD_CATALOG_ITEM = "ADD_CATALOG_ITEM"
export const ADD_CATALOG_ITEM_SUCCESS = "ADD_CATALOG_ITEM_SUCCESS"
export const ADD_CATALOG_ITEM_FAIL = "ADD_CATALOG_ITEM_FAIL"

export const UPDATE_CATALOG_ITEM = "UPDATE_CATALOG_ITEM"
export const UPDATE_CATALOG_ITEM_SUCCESS = "UPDATE_CATALOG_ITEM_SUCCESS"
export const UPDATE_CATALOG_ITEM_FAIL = "UPDATE_CATALOG_ITEM_FAIL"

export const DELETE_CATALOG_ITEM = "DELETE_CATALOG_ITEM"
export const DELETE_CATALOG_ITEM_SUCCESS = "DELETE_CATALOG_ITEM_SUCCESS"
export const DELETE_CATALOG_ITEM_FAIL = "DELETE_CATALOG_ITEM_FAIL"

export const SET_FIELD_ERRORS = "SET_FIELD_ERRORS" 